import {Event} from 'main.core';
import {InstancesManagerAsync} from 'asteq.instancesmanagerasync';

import {XhrSender} from './XhrSender';
import {BxComponentAction} from './BxComponentAction';

export class Form extends Event.EventEmitter {
    static instances = new InstancesManagerAsync();
    static availableSendersCodes = ['xhr', 'BxComponentAction'];
    static classes = {
        sending: 'form-sending',
    };

    constructor(options = {}) {
        super();
        this.setEventNamespace('BX.Asteq.Forms.Form');

        this.el = options.formId
            ? window[options.formId]
            : null;

        if (this.el instanceof HTMLCollection) {
            console.error('На странице расположены несколько форм с одинаковыми id');
            this.el = this.el[0];
        }

        this.senderCode = null;
        this.modal = null;
        this.captcha = null;

        if (!this.el) {
            return;
        }

        if (options?.sender?.code) {
            this.setSenderCode(options.sender.code);
        } else {
            this.setSenderCode(this.constructor.availableSendersCodes[0])
        }

        this.form = this.el.tagName === 'FORM'
            ? this.el
            : this.el.querySelector('[data-form]');

        if (this.form) {
            this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        if (options.captcha) {
            this.initCaptcha(options.captcha);
        }

        this.errorsBlock = document.querySelector('[data-errors=' + this.getId() + ']');
        this.resultBlock = document.querySelector('[data-result=' + this.getId() + ']');

        if (options.modalId) {
            this.modal = BX.Asteq.Modal.getInstance(options.modalId);
            if (this.modal) {
                this.modal.subscribe('open', this.onOpenModal.bind(this));
                this.modal.subscribe('close', this.onCloseModal.bind(this));
            }
        }

        this.constructor.addInstance(this.getId(), this);
    }

    initCaptcha(captchaOptions) {
        if (captchaOptions.type == 'bitrix') {
            BX.loadExt('asteq.forms.captcha.bitrixcaptcha').then(() => {
                this.captcha = new BX.Asteq.Forms.Captcha.BitrixCaptcha({
                    parent: this,
                    ...captchaOptions,
                });
            });
        } else if (captchaOptions.type == 'google') {
            BX.loadExt('asteq.forms.captcha.googlecaptcha').then(() => {
                this.captcha = new BX.Asteq.Forms.Captcha.GoogleCaptcha({
                    parent: this,
                    ...captchaOptions,
                });
            });
        }
    }

    getId() {
        return this.el?.id;
    }

    isSending() {
        if (!this.form) {
            return;
        }

        return this.form.classList.contains(this.constructor.classes.sending);
    }

    setSending(value) {
        if (!this.form) {
            return;
        }

        if (value) {
            this.form.classList.add(this.constructor.classes.sending);
        } else {
            this.form.classList.remove(this.constructor.classes.sending);
        }
    }

    showErrorHtml(html) {
        if (!this.errorsBlock) {
            return;
        }

        if (!html) {
            this.errorsBlock.setAttribute('hidden', '');
            return;
        }

        this.errorsBlock.innerHTML = html;
        this.errorsBlock.removeAttribute('hidden');
    }

    showResult(html) {
        if (!this.resultBlock
            || !this.form) {
            return;
        }

        if (!html) {
            this.resultBlock.setAttribute('hidden', '');
            this.form.removeAttribute('hidden');
            return;
        }

        this.resultBlock.innerHTML = html;
        this.resultBlock.removeAttribute('hidden');
        this.form.setAttribute('hidden', '');
    }

    setSenderCode(code) {
        if (!this.constructor.availableSendersCodes.includes(code)) {
            throw new Error('Передан код не корректного способа передачи данных');
        }

        this.senderCode = code;
    }

    getSenderCode() {
        return this.senderCode;
    }

    createSender() {
        const senderCode = this.getSenderCode();
        if (!senderCode) {
            return null;
        }

        if (senderCode == 'xhr') {
            return new XhrSender({form: this.form});
        } else if (senderCode == 'BxComponentAction') {
            return new BxComponentAction({form: this.form});
        }

        return null;
    }

    async submit() {
        if (this.isSending()) {
            return;
        }

        this.setSending(true);

        const sender = this.createSender();
        if (!sender) {
            return;
        }

        if (this.captcha) {
            await this.captcha.prepareFormBeforeSend();
        }

        const sendResult = await sender.send();
        const jsonResponse = sendResult.jsonResponse;

        if (!jsonResponse) {
            return;
        }

        if (jsonResponse.isSuccess) {
            this.showErrorHtml(null);

            if (jsonResponse.message) {
                this.showResult(jsonResponse.message);
            }

            if (this.form) {
                this.form.reset();
            }

        } else {
            if (jsonResponse.errorsHtml) {
                this.showErrorHtml(jsonResponse.errorsHtml);
            }
        }

        if (jsonResponse.captcha && this.captcha) {
            this.captcha.update(jsonResponse.captcha);
        }

        this.setSending(false);
    }

    applyValues(values = {}) {
        for (let code in values) {
            const inputEl = this.el.querySelector(`[data-code="${code}"]`);
            if (!inputEl) {
                continue;
            }

            inputEl.value = values[code];
        }
    }

    async onSubmit(e) {
        e.preventDefault();
        this.submit();
    }

    onOpenModal() {
        this.emit('shown');
    }

    onCloseModal() {
        this.showResult(null);
    }

    static addInstance(key, instance) {
        return this.instances.addInstance(key, instance);
    }

    static async getInstanceAsync(key) {
        return this.instances.getInstanceAsync(key);
    }

    static getInstance(key) {
        return this.instances.getInstance(key);
    }
}